import $ from 'jquery';
import '../styles/main.scss';
import { initMenu } from './components/menu';
import { initMosaic } from './components/mosaic';
import { initGalleryLightbox } from './components/lightbox';

$(function () {
  initMenu($);
  initMosaic($);
  initGalleryLightbox($);
});
